import React, { useEffect } from "react";
import { Form, Input, Select, Button, Row, Col } from "antd";
import useCommonsService from "../../../services/useCommonsService";
import { statusOptions } from "../../../utils/constantOptions";

const FirmUserForm = ({ form, onFinish, initialValues }) => {
  const { useGetFirmRoles } = useCommonsService();
  const { data: firmRoles } = useGetFirmRoles();
  const isEditMode = initialValues !== undefined;

  useEffect(() => {
    if (isEditMode) {
      form.setFieldsValue({
        ...initialValues,
        firmRole: initialValues.firmRole.name,
      });
    }
  }, [initialValues]);

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      style={{ maxWidth: 1000, margin: "0 auto" }}>
      <h2>Firma Kullanıcı Ekleme Formu</h2>

      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item
            name="name"
            label="İsim:"
            rules={[{ required: true, message: "Lütfen isim giriniz" }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="surname"
            label="Soyad:"
            rules={[{ required: true, message: "Lütfen soyad giriniz" }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item
            name="email"
            autoComplete="new-password"
            label="Eposta Adresi:"
            rules={[
              {
                required: true,
                type: "email",
                message: "Lütfen geçerli bir e-posta adresi giriniz",
              },
            ]}>
            <Input autoComplete="new-password" />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="phoneNumber"
            label="Telefon Numarası:"
            rules={[
              { required: true, message: "Lütfen telefon numarası giriniz" },
            ]}>
            <Input disabled={isEditMode} />
          </Form.Item>
        </Col>
      </Row>
      {!isEditMode ? (
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Şifre"
              name="password"
              rules={[{ required: true, message: "Lütfen şifrenizi giriniz" }]}>
              <Input.Password placeholder="Şifre" autoComplete="new-password" />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              label="Şifrenizi Tekrar Giriniz"
              name="confirmPassword"
              dependencies={["password"]}
              rules={[
                {
                  required: true,
                  message: "Lütfen şifrenizi tekrar giriniz",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Şifreler eşleşmiyor"));
                  },
                }),
              ]}>
              <Input.Password placeholder="Şifrenizi Tekrar Giriniz" />
            </Form.Item>
          </Col>
        </Row>
      ) : null}

      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item
            name="firmRole"
            label="Rol:"
            rules={[{ required: true, message: "Lütfen rol seçiniz" }]}>
            <Select options={firmRoles} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="status"
            label="Durum:"
            rules={[{ required: true, message: "Lütfen durum seçiniz" }]}>
            <Select options={statusOptions} />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item>
        <Row justify="center">
          <Col>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                minWidth: 150,
                height: "40px",
                borderColor: "#5f9ea0",
              }}>
              {isEditMode ? "Güncelle" : "Kaydet"}
            </Button>
          </Col>
        </Row>
      </Form.Item>
    </Form>
  );
};

export default FirmUserForm;
